
import { UPDATE_ALL_THE_THINGS } from './types';

export function updateValue(event, type) {
    return {
        type: type,
        value: event.target.value
    };
}

export function updateEverything(value) {
    return {
        type: UPDATE_ALL_THE_THINGS,
        value: value
    };
}
